import React from 'react';

import './styles.scss';

const Abas = ({
    abas,
    active,
    action
}) => {

    const handleClick = (abaId) => {
        if (action) {
            action(abaId);
        }
    }

    return (
        <div className='row ml-1 mt20 Abas'>
            <div className="AbasContainer">
                <ul>
                    {
                        abas &&
                        abas.map((aba) => (
                            <li
                                id={`aba-${aba.id}`}    
                                key={aba.id}
                                className={`${active === aba.id ? 'active' : ''}`}
                                onClick={() => handleClick(aba.id)}
                            >
                                {aba.nome}
                            </li>
                        ))
                    }
                </ul>
            </div>
        </div>
    )
}

export default Abas;